import { render, staticRenderFns } from "./detailAi.vue?vue&type=template&id=7772e280&scoped=true"
import script from "./detailAi.vue?vue&type=script&lang=js"
export * from "./detailAi.vue?vue&type=script&lang=js"
import style0 from "./detailAi.vue?vue&type=style&index=0&id=7772e280&prod&lang=less&scoped=true"
import style1 from "./detailAi.vue?vue&type=style&index=1&id=7772e280&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772e280",
  null
  
)

export default component.exports